import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";
import Typewriter from "typewriter-effect";

class Features extends Component {
  render() {
    return (
      <React.Fragment>
        <section className="section" id="features">
          <Container>
            <Row className="align-items-center">
              {/* Sección Izquierda */}
              <Col lg="5" className="order-2 order-lg-1">
                <div className="features-box mt-lg-0">
                  <h3 className="service-title" style={{ fontSize: "3rem", color: "#000" }}>
                    Servicio a gasolineras
                  </h3>
                  <p className="web-desc" style={{ fontSize: "1.5rem", fontWeight: "bold", color: "#000" }}>
                    <Typewriter
                      options={{
                        strings: [
                          "Instalación, programación, cambio o reparación:",
                          "Instalación, programación, cambio o reparación:",
                          "Instalación, programación, cambio o reparación:",
                          "Instalación, programación, cambio o reparación:",
                        ],
                        autoStart: true,
                        loop: true,
                        delay: 50,
                        deleteSpeed: 50,
                      }}
                    />
                  </p>
                  <p style={{ fontSize: "1rem", color: "#555" }}>
                    Dispensarios | Tanques | Cuarto de máquinas | Cuarto eléctrico | Techumbres
                  </p>
                  <p style={{ fontSize: "1rem", color: "#555" }}>
                    Somos una empresa mexicana, dedicada al mantenimiento especializado a estaciones de servicio (gasolineras), plantas distribuidoras de hidrocarburos, unidades de reparto de alto flujo (pipas), autoabastos.
                  </p>
                </div>
              </Col>

              {/* Sección Derecha */}
              <Col lg={{ size: 7, order: 2 }} xs={{ order: 1 }}>
                <div className="features-img mx-auto me-lg-0">
                  <h3 style={{ fontSize: "2rem", color: "#000", marginBottom: "1rem" }}>
                    ¿Por qué elegir nuestros servicios?
                  </h3>
                  <p style={{ fontSize: "1.2rem", color: "#555", marginBottom: "2rem" }}>
                    Contamos con diversas certificaciones y aprobaciones
                  </p>
                  <Row>
                    {/* Imágenes en 2x2 */}
                    <Col md="6" className="mb-4">
                      <img
                        src="assets/images/Aprobaciones/DGN.png"
                        alt="Imagen 1"
                        className="img-fluid rounded"
                        style={{ width: "100%", height: "auto" }}
                      />
                      
                    </Col>
                    <Col md="6" className="mb-4">
                      <img
                        src="assets/images/Aprobaciones/EMA.png"
                        alt="Imagen 2"
                        className="img-fluid rounded"
                        style={{ width: "100%", height: "auto" }}
                      />
                      
                    </Col>
                    <Col md="6" className="mb-4">
                      <img
                        src="assets/images/Aprobaciones/Gilbarco.png"
                        alt="Imagen 3"
                        className="img-fluid rounded"
                        style={{ width: "100%", height: "auto" }}
                      />
                      
                    </Col>
                    <Col md="6" className="mb-4">
                      <img
                        src="assets/images/Aprobaciones/NomA.png"
                        alt="Imagen 4"
                        className="img-fluid rounded"
                        style={{ width: "100%", height: "auto" }}
                      />
                      
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Título y 11 imágenes */}
        <section className="" id="otro-titulo">
          <Container>
            <Row>
              <Col>
                <h3
                  style={{
                    fontSize: "2rem",
                    color: "#FFFFFF",
                    backgroundColor: "#008dcc",
                    padding: "1rem 0",
                    textAlign: "center",
                  }}
                >
                  Marcas que manejamos
                </h3>
              </Col>
            </Row>
            {/* Reorganización de imágenes centradas */}
            <Row className="justify-content-center">
              {/* Fila 1 */}
              {[1, 3, 4, 5].map((num) => (
                <Col md="3" className="mb-4 text-center" key={`image${num}`}>
                  <img
                    src={`assets/images/Marcas/${num}M.png`}
                    alt={`Imagen ${num}`}
                    className="img-fluid rounded"
                    style={{ width: "100%", height: "auto" }}
                  />
                </Col>
              ))}
            </Row>
            <Row className="justify-content-center">
  {/* Fila 2 */}
  {[2, 6, 7, 11].map((num) => {
    // Determina la extensión según el número
    let extension = "jpg"; // Valor predeterminado
    if (num === 7) {
      extension = "jpeg"; // Para el caso específico
    }

    return (
      <Col md="3" className="mb-4 text-center" key={`image${num}`}>
        <img
          src={`assets/images/Marcas/${num}M.${extension}`}
          alt={`Imagen ${num}`}
          className="img-fluid rounded"
          style={{ width: "100%", height: "auto" }}
        />
      </Col>
    );
  })}
</Row>

            <Row className="justify-content-center">
              {/* Fila 3 */}
              {[8, 9, 10].map((num) => (
                <Col md="4" className="mb-4 text-center" key={`image${num}`}>
                  <img
                    src={`assets/images/Marcas/${num}M.png`}
                    alt={`Imagen ${num}`}
                    className="img-fluid rounded"
                    style={{ width: "70%", height: "auto" }}
                  />
                </Col>
              ))}
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}

export default Features;
